import { StoreState } from '../types';

import { NavigationState } from './types';

export const getNavigationState = (state: StoreState): NavigationState =>
  state.navigation;
